import { render, staticRenderFns } from "./btnFiltro.vue?vue&type=template&id=de056012"
import script from "./btnFiltro.vue?vue&type=script&lang=js"
export * from "./btnFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports